import { http } from '../helpers/axiosHelper';
class CandidatefieldService {
   async get() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/candidate-field').then((response) => {
         return response.data;
      });
   }
}
export default new CandidatefieldService();
